const ExpandLess = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z"/>
        </svg>
    )
}

export default ExpandLess;
